import React from 'react';

const SearchBar = ({ searchTerm, setSearchTerm, resultCount }) => (
  <div className="mb-6">
    <div className="flex items-center gap-2 bg-white rounded-lg shadow-sm border p-2">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        type="text"
        placeholder="Cari berdasarkan judul, pembuat, konten, atau informasi lainnya..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="flex-1 outline-none text-sm"
      />
      {searchTerm && (
        <button
          onClick={() => setSearchTerm('')}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          title="Clear search"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
    {searchTerm && (
      <div className="mt-2 flex items-center gap-2">
        <span className="text-sm text-gray-600">Hasil pencarian untuk:</span>
        <span className="text-sm font-medium bg-gray-100 px-2 py-1 rounded">{searchTerm}</span>
        <span className="text-sm text-gray-500">({resultCount} hasil)</span>
      </div>
    )}
  </div>
)

export default SearchBar;